var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAvatar6 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 60,
  height: 60,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#avatar-6_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FF6651",
  d: "M60 30C60 13.432 46.569 0 30 0 13.432 0 0 13.432 0 30c0 16.569 13.432 30 30 30 16.569 0 30-13.431 30-30"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFCB00",
  d: "M54.56 24.385c-1.848-.233-3.675-.968-3.675-.968-.735-.255-1.707-.575-2.487-.83-1.416-.677-3.133-1.022-5.135-1.022-1.46 0-2.873.313-4.155.907 0 0-2.408.89-4.3 1.948 0 0-.6.232-.94 0 0 0-.52-.555-1.058-.555H30v2.443c.615.012 1.317.062 1.715.212 0 0 1.058.34 1.058 1.075 0 0 .034.555-.233 1.005-.43.717-.273 1.598-.017 2.35 0 0 1.52 4.005 2.454 5.088l-.01-.03c1.783 2.81 5.005 4.44 8.293 4.427a9.7 9.7 0 0 0 3.873-.823c3.012-1.332 5.367-4.265 5.78-7.56l.005.008c.22-1.435.39-4.41.39-4.41.035-.627.7-.717.7-.717l.734-.125c.466-.125.466-.683.466-.683v-1.183c0-.502-.645-.555-.645-.555z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#59C6F4",
  d: "M43.26 39.323a8.27 8.27 0 1 0 0-16.54 8.27 8.27 0 0 0 0 16.54"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#35A4D3",
  d: "M48.588 24.728a8.27 8.27 0 0 1-11.65 11.65 8.27 8.27 0 1 0 11.65-11.65"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFCB00",
  d: "M5.44 24.385c1.847-.233 3.675-.968 3.675-.968.735-.255 1.707-.575 2.487-.83 1.415-.677 3.133-1.022 5.136-1.022 1.46 0 2.872.313 4.154.907 0 0 2.408.89 4.3 1.948 0 0 .6.232.94 0 0 0 .52-.555 1.058-.555H30v2.443c-.615.012-1.317.062-1.715.212 0 0-1.058.34-1.058 1.075 0 0-.035.555.233 1.005.43.717.273 1.598.017 2.35 0 0-1.52 4.005-2.454 5.088l.01-.03c-1.783 2.81-5.006 4.44-8.293 4.427a9.7 9.7 0 0 1-3.872-.823c-3.013-1.332-5.368-4.265-5.78-7.56l-.006.008c-.22-1.435-.39-4.41-.39-4.41-.035-.627-.7-.717-.7-.717l-.735-.125c-.465-.125-.465-.683-.465-.683v-1.183c0-.502.645-.555.645-.555z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#59C6F4",
  d: "M16.74 39.323a8.27 8.27 0 1 0 0-16.54 8.27 8.27 0 0 0 0 16.54"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#35A4D3",
  d: "M22.065 24.728a8.27 8.27 0 0 1-11.65 11.65 8.27 8.27 0 1 0 11.65-11.65"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "avatar-6_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h60v60H0z"
})))));
export { SvgAvatar6 as ReactComponent };
export default __webpack_public_path__ + "static/media/avatar-6.6642b9035a5a9bfe681b.svg";